import './icon.scss';

export const Logo = ({ size }: { size: 'large' | 'medium' | 'small' }) => {
    return <div className={`logo-icon ${size}`}>

    </div>;
};
